import React, { useState } from "react";
import styles from "./Questions.module.scss";

import ArrowDropdown from "../../../../img/IconComponents/ArrowDropdown";
import { useTranslation } from "react-i18next";

const Questions = () => {
  const { t } = useTranslation();

  const questionsArr = [
    {
      question: t("Who is Deutsche Anbaugesellschaft DAG?"),
      answer: t(
        `We are a cultivation and technology company from Hamburg. In the course of cannabis legalization, we offer cannabis clubs in Germany a complete solution for cultivation at our huge site. In the second stage, we are planning commercial cultivation and the sale of cannabis in licensed specialist stores.`
      ),
    },
    {
      question: t("When will cannabis become legal in Germany?"),
      answer: t(
        `On February 23, the Bundestag voted by a large majority in favor of the Cannabis Act. The Cannabis Act is to come into force on April 1. Cultivation by cannabis clubs is to begin on July 1.`
      ),
    },
    {
      question: t("What makes the cannabis market so interesting?"),
      answer: t(
        `Cannabis is being legalized in more and more countries around the world. The profits of the cannabis industry are gigantic. According to a report by Fortune Business Insights, the global cannabis market was already worth over USD 20 billion in 2020 and is expected to reach USD 200 billion by 2028.`
      ),
    },
    {
      question: t(
        "What is the German Cannabis Token (DECT)?"
      ),
      answer: t(
        `The DECT is the only crypto asset related to cannabis legalization in Germany and to real cannabis plants. The DECT makes it possible to profit permanently from the harvest yields of cannabis plants via a planting site NFT. The number of units issued is limited to 180,000. In 2025, the DECT will be tradable on several crypto exchanges.`
      ),
    },
    {
      question: t(
        "How often are the cannabis plants harvested?"
      ),
      answer: t(
        `The plants are usually harvested every 10-12 weeks, i.e. many times a year. The plants are then dried for a further 1-2 weeks. Then they can be further processed, packaged and delivered.`
      ),
    },
    {
      question: t("What is the maximum number of DECT tokens that can be purchased?"),
      answer: t(
        `A maximum of 40 DECT tokens can be purchased per person. The small number of tokens is strictly limited. Due to its many possible uses for both private individuals and companies, demand is already high.`
      ),
    },
    {
      question: t("What does a DECT cost?"),
      answer: t(
        `A DECT costs 2,500 euros including VAT.`
      ),
    },
    {
      question: t("What payment options are available?"),
      answer: t(
        `As a German company, we accept bank transfer and cryptocurrencies via Coinbase Commerce as a means of payment.`
      ),
    },
    {
      question: t("How is the project being legally supported?"),
      answer: t(
        `We are working closely with several law firms specializing in crypto and capital market law, which have developed the legal aspects of the project and are supporting it.`
      ),
    },
  ];
  const [collapseQuestions, setCollapseQuestions] = useState([]);
  const handleQuestions = (i) => {
    const newCollapseQuestions = [...collapseQuestions];
    newCollapseQuestions[i] = !newCollapseQuestions[i];
    setCollapseQuestions(newCollapseQuestions);
  };
  return (
    <section className={styles.questions} id="faq">
      <div
        className="container"
      >
        <div className={styles.questions__head}>
          <div>
            <h2>{t("Frequently asked questions")}</h2>
          </div>
        </div>
        <div className={styles.questions__inner}>
          <div className={styles.questions__inner_right}>
            {questionsArr.map((q, i) => {
              const { question, answer } = q;
              return (
                <div
                  className={`${styles.question} ${
                    collapseQuestions[i] === true ? styles.opened : ""
                  }`}
                  key={i}
                  onClick={() => handleQuestions(i)}
                >
                  <div className={styles.question_title}>
                    <h4>{question}</h4>
                    <ArrowDropdown />
                  </div>
                  <p>{answer}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Questions;
